import { UseBookingContextValue } from './UseBookingContextValue';
import { useContext } from 'react';
import { BookingStateContext } from './BookingStateContext';

export function useBookingContext(): UseBookingContextValue {
  const context = useContext(BookingStateContext);

  if (context === null) {
    throw new Error('useBookingContext was used outside of its Provider');
  }

  return [context.bookingState, context.setBookingState];
}
